import { useEffect, useState } from "react";

// TODO: move this to the same config/env source usePrograms() and
// OurServices.jsx already use, so it isn't duplicated in three places.
const CLINIC_ID = "6a3ba96dc8e05c65af7f0ef0";
const SERVICES_URL = `https://api.avexa.net/clinic-onboarding/clinics/${CLINIC_ID}/services`;

/**
 * Fetches the clinic's full service catalogue once and exposes it as-is.
 * Screens that need a subset (by care need / life stage / condition focus)
 * filter this list client-side — see the filter helpers in FindCare.jsx.
 */
export function useServices() {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const fetchServices = async () => {
      try {
        setLoading(true);
        const res = await fetch(SERVICES_URL);
        if (!res.ok) throw new Error("Failed to fetch services");
        const json = await res.json();
        const active = Array.isArray(json)
          ? json.filter((s) => s.status !== "INACTIVE")
          : [];
        if (!cancelled) setServices(active);
      } catch (err) {
        if (!cancelled) setError(err);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchServices();
    return () => {
      cancelled = true;
    };
  }, []);

  return { services, loading, error };
}